<template>
  <v-snackbar
    :timeout="10000"
    :value="show"
    right
    bottom
    multi-line
    :color="color"
    app
  >
    <v-icon>{{ icon }}</v-icon>
    {{ notifiedMessage }}
    <template v-slot:action="{ attrs }">
      <v-btn
        color="white"
        icon
        v-bind="attrs"
      >
        <v-icon @click.native="show = false">mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "LayoutsAdminNotifier",
  data() {
    return {
      show: false,
      notifiedMessage: ""
    };
  },
  computed: {
    ...mapState('notifier', ['icon', 'color', 'message'])
  },
  methods: {
    ...mapActions('notifier', ['resetNotifier'])
  },
  watch: {
    message(val) {
      if (val !== "") {
        this.notifiedMessage = this.message;
        this.show = true;
        let me = this;
        setTimeout(function() {
          me.resetNotifier()
          me.show = false
        }, 8000);
      }
    }
  }
};
</script>
